import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { User, Mail, Lock, Phone, UserCheck,CheckCircle,MessageSquare } from "react-feather"
import Input from "@/components/Input"
import Button from "@/components/Button"
import Alert from "@/components/Alert"
import Loader from '../components/Loader'
import api from '@/api'

export default function RegisterForm({ onSubmit }) {
	const [fullname, setFullname] = useState("")
	const [email, setEmail] = useState("")
	const [phone, setPhone] = useState("")
	const [gender, setGender] = useState("")
	const [password, setPassword] = useState("")
	const [confirmPassword, setConfirmPassword] = useState("")
	const [error, setError] = useState(null)
	const [loading, setLoading] = useState(false)
	const [isAdmin, setIsAdmin] = useState(false)
	const [refNo,setRefNo] = useState("")
	const [otp,setOtp] = useState("")
	const [showOtp,setShowOtp] = useState(false)
	const [verified,setVerified] = useState(false)

	const handleSubmit = async e => {
		e.preventDefault()
		if (password.length < 6) {
			setError("password must be atleast 6 characters")
			return
		}
		if (password !== confirmPassword) {
			setError("passwords don't match")
			return
		}
		setLoading(true)
		const resp = await onSubmit({fullname, email, phone, gender, password, confirmPassword,verified})
		setLoading(false)
		if (resp.status == "error" || resp.status == "400") {
			setError(resp.message)
		}
	}

	const handlePhoneChange = (e) => {
	const value = e.target.value.replace(/\D/g, ""); // only numbers
	setPhone(value);
	if (value.length == 10) {
		checkAdmin(value);
	} else {
		setIsAdmin(false);
		setShowOtp(false);
		setVerified(false);
	}
	};

	const checkAdmin = async (phone) => {
	try {
	  setLoading(true);
	  const resp = await api.verifyAdminUser(phone);
		if (resp?.status == 200) {
		setIsAdmin(true);
		} else {
		setIsAdmin(false);
		}
		} catch (err) {
			console.log(err);
			setIsAdmin(false);
		} finally {
			setLoading(false);
		}
   };

   const sendOtp = async () => {
	try {
	  setLoading(true);
	  const resp = await api.sendOtp(phone);
	  if(resp[phone]){
		setRefNo(resp[phone])
		setShowOtp(true);
	  }
		} catch (err) {
			console.log(err);
			setIsAdmin(false);
		} finally {
			setLoading(false);
		}
   };

   const verifyOtp = async () => {
	try {
	  setLoading(true);
	  const resp = await api.verifyOtp(phone,refNo,otp);
	  if (resp.uid){
		setVerified(true)
		setIsAdmin(false)
		setShowOtp(false)
		setOtp("");
	  }
		} catch (err) {
			console.log(err);
			setShowOtp(false);
			setOtp("");
		} finally {
			setLoading(false);
			setOtp("");
		}
   };

	useEffect(() => {
		return () => {
			setLoading(false)
		}
	}, [])

	return (
		<form 
			onSubmit={handleSubmit}
			className="flex items-center flex-col space-y-2"
			>
			<Input 
				value={fullname}
				icon={<User width={20} height={20} />}
				onChange={e => setFullname(e.target.value)}
				type="text" placeholder="Full Name" required />
			<Input 						
				value={email}
				icon={<Mail width={20} height={20} />}
				onChange={e => setEmail(e.target.value)}
				type="email" placeholder="Email" required />
			<Input
				as="select"
				value={gender}
				icon={<User width={20} height={20} />}
				onChange={e => setGender(e.target.value)}
				required
				>
				<option value="" disabled>
					Select gender
				</option>
				<option value="Male">Male</option>
				<option value="Female">Female</option>
				<option value="Other">Other</option>
			</Input>
			<Input 
				value={password}
				icon={<Lock width={20} height={20} />}
				onChange={e => setPassword(e.target.value)}
				type="password" placeholder="Password" required />
			<Input
				value={confirmPassword}
				icon={<Lock width={20} height={20} />}
				onChange={e => setConfirmPassword(e.target.value)} 
				type="password" placeholder="Confirm Password" required />
			<Input 						
				value={phone}
				icon={verified?<CheckCircle width={20} height={20} color="green"/>:<Phone width={20} height={20} />}
				// onChange={e => setPhone(e.target.value)}
				onChange={handlePhoneChange}
				maxLength={10}
				type="phone" placeholder="Phone" required />

			{showOtp && (
			<Input 						
				value={otp}
				icon={<MessageSquare width={20} height={20} />}
				onChange={e => setOtp(e.target.value)}
				// onChange={null}
				maxLength={6}
				type="otp" placeholder="Enter OTP" required />
            )}

				{isAdmin && (
				<Button 
				className="w-full !mt-6 !text-base !rounded-full" 
				type=""
				onClick={showOtp ? verifyOtp : sendOtp}
				disabled={loading}
			>
				{loading ? <Loader /> : showOtp ? "Verify OTP ":"Send OTP" }
			</Button>
			)}

			{error && <Alert heading="" body={error} danger />}
            
			<Button 
				className="w-full !mt-6 !text-base !rounded-full" 
				type="submit"
				disabled={loading || showOtp || isAdmin}
			>
				{loading ? <Loader /> : "Register"}
			</Button>

			<Link to="/login">
				<Button link>
					Already have an account?
				</Button>
			</Link>
		</form>
	)
}